var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09 7.427a.682.682 0 01-.481-.19L.88 4.508a.682.682 0 01.91-.973l2.3 2.282L9.008.791a.682.682 0 11.972.91l-5.4 5.508a.682.682 0 01-.49.218z",
    fill: "#fff"
  })));
}
export default SvgCheckboxTick;